import dayjs from 'dayjs';

export function formatTemp(value: number | null | undefined, unit = '°C'): string {
  if (value === null || value === undefined) return '--';
  return `${value.toFixed(1)}\u00a0${unit}`;
}

export function formatPressure(value: number | null | undefined, unit = 'Mpa'): string {
  if (value === null || value === undefined) return '--';
  return `${value.toFixed(2)}\u00a0${unit}`;
}

export function formatCurrent(value: number | null | undefined): string {
  if (value === null || value === undefined) return '--';
  return `${value.toFixed(1)}\u00a0A`;
}

export function formatFrequency(value: number | null | undefined): string {
  if (value === null || value === undefined) return '--';
  return `${value}\u00a0Hz`;
}

export function formatEhi(value: number | null | undefined): string {
  if (value === null || value === undefined) return '--';
  return `${value.toFixed(1)}`;
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '--';
  return dayjs(value).format('YYYY-MM-DD HH:mm:ss');
}

export function formatTimeAgo(value: string | null | undefined): string {
  if (!value) return '--';
  const now = dayjs();
  const target = dayjs(value);
  const diffSec = now.diff(target, 'second');
  if (diffSec < 60) return `${diffSec} 秒前`;
  if (diffSec < 3600) return `${Math.floor(diffSec / 60)} 分鐘前`;
  if (diffSec < 86400) return `${Math.floor(diffSec / 3600)} 小時前`;
  return `${Math.floor(diffSec / 86400)} 天前`;
}

export function isDataStale(value: string | null | undefined, thresholdSec = 300): boolean {
  if (!value) return true;
  return dayjs().diff(dayjs(value), 'second') > thresholdSec;
}

export function boolToText(value: boolean | null | undefined, onText = '運行', offText = '停止'): string {
  if (value === null || value === undefined) return '--';
  return value ? onText : offText;
}
